import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import ConfirmDialog from '../ConfirmDialog';

export default function LogoutConfirm({ handleClose }) {
  const { t } = useTranslation();
  const { logout } = useAuth0();

  const handleLogout = () => {
    logout({
      logoutParams: { returnTo: window.location.origin },
    });
  };

  return (
    <ConfirmDialog
      open
      onClose={handleClose}
      title={t('logout.title')}
      body={t('logout.description')}
      cancelLabel={t('logout.return')}
      confirmLabel={t('logout.title')}
      onConfirm={handleLogout}
      disableBackdropClose
    />
  );
}
